<template>
    <div class="roof-all">
        <div class="container">
            <h1>Roofs</h1>

            <div class="card">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="roof in roofs" v-bind:class="{editing: editing(roof), images: editingImages(roof)}">
                        <div class="d-flex align-items-center">
                            <img v-if="roof.images && roof.images.swatch" :src="'https://s3.eu-west-2.amazonaws.com/ngb-mpdb/' + roof.images.swatch[0]" width="32" height="32" class="mr-2" />
                            <strong v-if="!editing(roof)">{{roof.name}} <span v-if="roof.prefix">({{roof.prefix}})</span></strong>
                            <b-form-input v-model="roof.name" v-if="editing(roof)" class="mr-4" placeholder="Full name (e.g. Polycarbonate Clear)"></b-form-input>
                            <b-form-input v-model="roof.prefix" v-if="editing(roof)" class="mr-4" placeholder="Prefix (e.g. PC)"></b-form-input>

                            <div class="btn-group ml-auto">
                                <b-button type="button" class="mr-2" v-on:click="edit(roof)" v-if="!editing(roof) && !editingImages(roof)">
                                    Edit
                                </b-button>

                                <b-button type="button" class="mr-2" variant="success" v-on:click="save(roof)" v-if="editing(roof) || editingImages(roof)">
                                    Save
                                </b-button>

                                <b-button type="button" class="mr-2" variant="danger" v-on:click="del(roof)" v-if="editing(roof)">
                                    Delete
                                </b-button>

                                <b-button type="button" v-on:click="cancel()" v-if="editing(roof) || editingImages(roof)">
                                    Cancel
                                </b-button>

                                <b-button type="button" v-on:click="images(roof)" v-if="!editing(roof) && !editingImages(roof)">
                                    Images
                                </b-button>
                            </div>
                        </div>

                        <div class="mt-4" v-if="editingImages(roof)">
                            <h3>Swatch</h3>
                            <product-images v-bind:product="roof" type="swatch" editable="true" default-message="Upload colour swatch here" min-width="400" min-height="400" max-images="1"></product-images>
                        </div>
                    </li>
                </ul>
            </div>

            <b-button type="button" size="lg" class="ml-auto mr-auto mt-4 d-block" variant="success" v-on:click="create()">Create roof</b-button>
        </div>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
  import Simplert from 'vue2-simplert'
  import ProductImages from './ProductImages.vue'

  export default {
    name: 'roofAll',
    props: ['fb'],
    components: {
      Simplert,
      ProductImages
    },
    firebase () {
      return {
        roofs: this.fb.database().ref('roofs').orderByChild('name')
      }
    },
    data () {
      return {
        editingKey: null,
        editingImagesKey: null
      }
    },
    methods: {
      edit (roof) {
        this.editingImagesKey = null
        this.editingKey = roof['.key']
      },
      editing (roof) {
        return this.editingKey === roof['.key']
      },
      del (roof) {
        this.$firebaseRefs.roofs.child(roof['.key']).remove()
        this.$refs.simplert.openSimplert({
          title: 'Deleted',
          type: 'info',
          message: 'The product roof and all associated images have been deleted'
        })
      },
      images (roof) {
        this.editingKey = null
        this.editingImagesKey = roof['.key']
      },
      editingImages (roof) {
        return this.editingImagesKey === roof['.key']
      },
      save (roof) {
        let f = this.fb.database().ref('roofs/' + roof['.key'])
        delete roof['.key']
        f.set(roof).then(() => {
          this.$refs.simplert.openSimplert({
            title: 'Saved',
            type: 'info',
            message: 'Saved'
          })

          this.cancel()
        })
      },
      cancel () {
        this.editingKey = null
        this.editingImagesKey = null
      },
      create () {
        let push = this.$firebaseRefs.roofs.push({
          name: ''
        })
        let self = this
        push.then(() => {
          self.cancel()
          self.editingKey = push.key
        }, () => {
          console.error(arguments)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/RoofAll.vue